import React from 'react';
import { Divider, Select, DatePicker } from 'antd';
import { Form } from '..';
import Wrapper from './style';
import commonMessage from '../../configs/commonMessage';
import {
  educationTypes,
  relationShipStatus,
  parentalStatus,
  incomePerMonths,
} from '../../configs/contact';

const { Option } = Select;

const Index = () => {
  return (
    <Wrapper>
      <Divider />
      <div className="black1 font-subtitle2_medium">Bio Detail</div>
      <div className="component_additional_bio_details_forms">
        <Form.Item
          name="gender"
          label="Gender"
          hasFeedback
          rules={[
            {
              required: true,
              message: commonMessage.required('gender'),
            },
          ]}
        >
          <Select placeholder="Choose contact gender">
            <Option value={1}>Male</Option>
            <Option value={2}>Female</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="birth_date"
          label="Birth date"
          hasFeedback
          rules={[
            {
              required: true,
              message: commonMessage.required('birth date'),
            },
          ]}
        >
          <DatePicker format="DD MMMM YYYY" placeholder="DD MMM YYYY" />
        </Form.Item>
        <Form.Item name="nationality" label="Nationality">
          <Select placeholder="Choose nationality">
            <Option value="indonesia">Indonesia</Option>
          </Select>
        </Form.Item>
      </div>
      <Divider />
      <div className="component_additional_bio_forms">
        <Form.Item name="education_type" label="Education Type (Optional)">
          <Select placeholder="Education Type">
            {educationTypes.map((item) => {
              return (
                <Select.Option value={item?.value} key={item?.id}>
                  {item?.name}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item name="married_status" label="Relationship Status (Optional)">
          <Select placeholder="Relationship Status">
            {relationShipStatus.map((item) => {
              return (
                <Select.Option value={item?.value} key={item?.id}>
                  {item?.name}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      </div>
      <div className="component_additional_bio_forms">
        <Form.Item name="parental_status" label="Parental Status (Optional)">
          <Select placeholder="Parental Status">
            {parentalStatus.map((item) => {
              return (
                <Select.Option value={item?.value} key={item?.id}>
                  {item?.name}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item name="income_per_month" label="Income per Month (Optional)">
          <Select placeholder="Income per Month">
            {incomePerMonths.map((item) => {
              return (
                <Select.Option value={item?.value} key={item?.id}>
                  {item?.name}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      </div>
    </Wrapper>
  );
};

export default Index;
